// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"a9cc3627","650":"72b722be","875":"81e22fa2","942":"8a2cc98b"}[chunkId] + ".chunk.js";
};